import rConfig from 'config/remoteConfig.default';
import { put, takeEvery } from 'redux-saga/effects';
import { Notification } from 'zComponents/atoms';
import { Button } from 'zui/Antd';
import { remoteConfigActions } from './slice';

// Remote config saga
function* loadRemoteConfigSaga() {
	try {
		yield put(remoteConfigActions.loadRemoteConfigSuccess(rConfig));
	} catch (error) {
		yield put(remoteConfigActions.loadRemoteConfigError(error));
		Notification(
			'error',
			'Error loading data! Please refresh the page and try again.',
			<Button onClick={() => window.location.reload()}>Try again!</Button>
		);
	}
}

export default function* remoteConfigSaga() {
	yield takeEvery(remoteConfigActions.loadRemoteConfig, loadRemoteConfigSaga);
}
